import { EVA_TO_IONICONS, PAGE_ICONS } from "@congrs/schemas";
import { Ionicon } from "./Ionicon";
import { Select } from "react-hook-form-mantine";
import { Group, Text, Flex } from "@mantine/core";

// Values stay Eva names — that is what the API stores and the legacy mobile app
// reads — while options are labelled and drawn as the Ionicon they map to.
// Several Eva names share one Ionicon, so only the first of each is offered.
const iconOptions = Object.values(
  PAGE_ICONS.reduce((options, icon) => {
    const ionicon = EVA_TO_IONICONS[icon];

    if (!options[ionicon]) {
      options[ionicon] = {
        value: icon,
        label: ionicon
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      };
    }

    return options;
  }, {})
);

const IconSelect = ({ currentIcon, ...props }) => {
  const renderIconOption = ({ option }) => {
    return (
      <Group>
        <Ionicon name={EVA_TO_IONICONS[option.value]} />
        <Text>{option.label}</Text>
      </Group>
    );
  };

  return (
    <Flex align="center" gap="xs">
      <Ionicon
        name={EVA_TO_IONICONS[currentIcon]}
        size={40}
        styles={{ root: { marginTop: 24, paddingLeft: 8 } }}
      />
      <Select
        style={{ flex: 1 }}
        label="Icon"
        placeholder="Select icon"
        searchable
        clearable={false}
        allowDeselect={false}
        limit={50}
        data={iconOptions}
        renderOption={renderIconOption}
        {...props}
      />
    </Flex>
  );
};

export default IconSelect;
